@if ($getGeometryAttributeLike(); as getGeometryAttributeLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="getGeometryAttributeLike" [key]="'attributeSet'" [label]="'Attribute set'"></cm-value-slot>
            <cm-value-slot [node]="getGeometryAttributeLike" [key]="'attributeName'" [label]="'Attribute'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($getGeometryAttributeComponentLike(); as getGeometryAttributeComponentLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="getGeometryAttributeComponentLike" [key]="'attribute'" [label]="'Attribute'"></cm-value-slot>
            <cm-value-slot
                [node]="getGeometryAttributeComponentLike"
                [key]="'component'"
                [label]="'Component'"
                [selectionPossibilities]="componentOptionsSelectionPossibilities"
            ></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($packOperatorLike(); as packOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="packOperatorLike" [key]="'x'" [label]="'X'"></cm-value-slot>
            <cm-value-slot [node]="packOperatorLike" [key]="'y'" [label]="'Y'"></cm-value-slot>
            <cm-value-slot [node]="packOperatorLike" [key]="'z'" [label]="'Z'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($mathOperatorLike(); as mathOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot
                #mathOperatorParameter
                [node]="$mathOperatorSelectionDummyNode()"
                [key]="'operator'"
                [label]="'Operator'"
                [selectionPossibilities]="mathOperatorSelectionPossibilities"
                (onChanged)="onMathOperatorSelectionChange($event)"
            >
            </cm-value-slot>
            @if ($unaryMathOperatorLike(); as unaryMathOperatorLike) {
                <cm-value-slot [node]="unaryMathOperatorLike" [key]="'arg'" [label]="'Arg'"></cm-value-slot>
            }
            @if ($binaryMathOperatorLike(); as binaryMathOperatorLike) {
                <cm-value-slot [node]="binaryMathOperatorLike" [key]="'arg1'" [label]="'Arg 1'"></cm-value-slot>
                <cm-value-slot [node]="binaryMathOperatorLike" [key]="'arg2'" [label]="'Arg 2'"></cm-value-slot>
            }
        </ng-container>
    </cm-inspector-section>
}
@if ($flattenOperatorLike(); as flattenOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="flattenOperatorLike" [key]="'attribute'" [label]="'Attribute'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($constOperatorLike(); as constOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="constOperatorLike" [key]="'attribute'" [label]="'Attribute'"></cm-value-slot>
            <cm-value-slot [node]="constOperatorLike" [key]="'value'" [label]="'Value'"></cm-value-slot>
            <cm-value-slot
                [node]="constOperatorLike"
                [key]="'type'"
                [label]="'Type'"
                [selectionPossibilities]="constOperatorTypeSelectionPossibilities"
            ></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($castOperatorLike(); as castOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="castOperatorLike" [key]="'attribute'" [label]="'Attribute'"></cm-value-slot>
            <cm-value-slot
                [node]="castOperatorLike"
                [key]="'type'"
                [label]="'Type'"
                [selectionPossibilities]="castOperatorTypeSelectionPossibilities"
            ></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($diffOperatorLike(); as diffOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="diffOperatorLike" [key]="'independentAttribute'" [label]="'Independent attribute'"></cm-value-slot>
            <cm-value-slot [node]="diffOperatorLike" [key]="'dependentAttribute'" [label]="'Dependent attribute'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($primitiveLike(); as primitiveLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            @if ($pointGeometryPrimitiveLike(); as pointGeometryPrimitiveLike) {
                <cm-value-slot
                    #pointGeometryPrimitiveParameter
                    [node]="$pointGeometryPrimitiveSelectionDummyNode()"
                    [key]="'primitive'"
                    [label]="'Primitive'"
                    [selectionPossibilities]="pointGeometryPrimitiveSelectionPossibilities"
                    (onChanged)="onPointGeometryPrimitiveSelectionChange($event)"
                >
                </cm-value-slot>
            }
            @if ($curveGeometryPrimitiveLike(); as curveGeometryPrimitiveLike) {
                <cm-value-slot
                    #curveGeometryPrimitiveParameter
                    [node]="$curveGeometryPrimitiveSelectionDummyNode()"
                    [key]="'primitive'"
                    [label]="'Primitive'"
                    [selectionPossibilities]="curveGeometryPrimitiveSelectionPossibilities"
                    (onChanged)="onCurveGeometryPrimitiveSelectionChange($event)"
                >
                </cm-value-slot>
            }
            @if ($meshGeometryPrimitiveLike(); as meshGeometryPrimitiveLike) {
                <cm-value-slot
                    #meshGeometryPrimitiveParameter
                    [node]="$meshGeometryPrimitiveSelectionDummyNode()"
                    [key]="'primitive'"
                    [label]="'Primitive'"
                    [selectionPossibilities]="meshGeometryPrimitiveSelectionPossibilities"
                    (onChanged)="onMeshGeometryPrimitiveSelectionChange($event)"
                >
                </cm-value-slot>
            }

            @if ($pointGeometryPrimitiveLinePointsLike(); as pointGeometryPrimitiveLinePointsLike) {
                <cm-value-slot [node]="pointGeometryPrimitiveLinePointsLike" [key]="'numPoints'" [label]="'Points count'"></cm-value-slot>
            }
            @if ($curveGeometryPrimitiveLineLike(); as curveGeometryPrimitiveLineLike) {
                <cm-value-slot [node]="curveGeometryPrimitiveLineLike" [key]="'numSegments'" [label]="'Segments count'"></cm-value-slot>
            }
            @if ($primitiveLikeWithX0X1Parameters(); as primitiveLikeWithX0X1Parameters) {
                <cm-value-slot [node]="primitiveLikeWithX0X1Parameters" [key]="'x0'" [label]="'X0'"></cm-value-slot>
                <cm-value-slot [node]="primitiveLikeWithX0X1Parameters" [key]="'x1'" [label]="'X1'"></cm-value-slot>
            }
            @if ($primitiveLikeWithY0Y1Parameters(); as primitiveLikeWithY0Y1Parameters) {
                <cm-value-slot [node]="primitiveLikeWithY0Y1Parameters" [key]="'y0'" [label]="'Y0'"></cm-value-slot>
                <cm-value-slot [node]="primitiveLikeWithY0Y1Parameters" [key]="'y1'" [label]="'Y1'"></cm-value-slot>
            }
            @if ($primitiveLikeWithZ0Z1Parameters(); as primitiveLikeWithZ0Z1Parameters) {
                <cm-value-slot [node]="primitiveLikeWithZ0Z1Parameters" [key]="'z0'" [label]="'Z0'"></cm-value-slot>
                <cm-value-slot [node]="primitiveLikeWithZ0Z1Parameters" [key]="'z1'" [label]="'Z1'"></cm-value-slot>
            }
            @if ($pointGeometryPrimitivePointSetLike(); as pointGeometryPrimitivePointSetLike) {
                @if (pointGeometryPrimitivePointSetLike.pointSet1; as pointSet1) {
                    <cm-value-slot [node]="pointSet1" [key]="'data'" [label]="'Data'"> </cm-value-slot>
                }
                @if (pointGeometryPrimitivePointSetLike.pointSet2; as pointSet2) {
                    @for (entry of pointSet2.parameters.data; track $index) {
                        <div class="cm-point-primitive-point-set-entry-container">
                            <div class="cm-point-primitive-point-set-entry-slots">
                                <div class="cm-point-primitive-point-set-entry-slot">
                                    <cm-value-slot
                                        [node]="pointSet2"
                                        [key]="'data'"
                                        [subKey]="[$index, 'x']"
                                        [label]="'X (' + ($index + 1) + ')'"
                                    ></cm-value-slot>
                                </div>
                                <div class="cm-point-primitive-point-set-entry-slot">
                                    <cm-value-slot
                                        [node]="pointSet2"
                                        [key]="'data'"
                                        [subKey]="[$index, 'y']"
                                        [label]="'Y (' + ($index + 1) + ')'"
                                    ></cm-value-slot>
                                </div>
                            </div>
                            <div class="cm-remove-icon">
                                <i class="far fa-trash" (click)="removeEntryForPointGeometryPrimitivePointSetLike(pointSet2, $index)"></i>
                            </div>
                        </div>
                    }
                    <cm-button class="cm-action-button" (click)="addEntryForPointGeometryPrimitivePointSetLike(pointSet2)">
                        <ng-container cm-text> Add </ng-container>
                    </cm-button>
                }
                @if (pointGeometryPrimitivePointSetLike.pointSet3; as pointSet3) {
                    @for (entry of pointSet3.parameters.data; track $index) {
                        <div class="cm-point-primitive-point-set-entry-container">
                            <div class="cm-point-primitive-point-set-entry-slots">
                                <div class="cm-point-primitive-point-set-entry-slot">
                                    <cm-value-slot
                                        [node]="pointSet3"
                                        [key]="'data'"
                                        [subKey]="[$index, 'x']"
                                        [label]="'X (' + ($index + 1) + ')'"
                                    ></cm-value-slot>
                                </div>
                                <div class="cm-point-primitive-point-set-entry-slot">
                                    <cm-value-slot
                                        [node]="pointSet3"
                                        [key]="'data'"
                                        [subKey]="[$index, 'y']"
                                        [label]="'Y (' + ($index + 1) + ')'"
                                    ></cm-value-slot>
                                </div>
                                <div class="cm-point-primitive-point-set-entry-slot">
                                    <cm-value-slot
                                        [node]="pointSet3"
                                        [key]="'data'"
                                        [subKey]="[$index, 'z']"
                                        [label]="'Z (' + ($index + 1) + ')'"
                                    ></cm-value-slot>
                                </div>
                            </div>
                            <div class="cm-remove-icon">
                                <i class="far fa-trash" (click)="removeEntryForPointGeometryPrimitivePointSetLike(pointSet3, $index)"></i>
                            </div>
                        </div>
                    }
                    <cm-button class="cm-action-button" (click)="addEntryForPointGeometryPrimitivePointSetLike(pointSet3)">
                        <ng-container cm-text> Add </ng-container>
                    </cm-button>
                }
            }
            @if ($meshGeometryPrimitiveGrid2Like(); as meshGeometryPrimitiveGrid2Like) {
                <cm-value-slot [node]="meshGeometryPrimitiveGrid2Like" [key]="'originX'" [label]="'Origin X'"></cm-value-slot>
                <cm-value-slot [node]="meshGeometryPrimitiveGrid2Like" [key]="'originY'" [label]="'Origin Y'"></cm-value-slot>
                <cm-value-slot [node]="meshGeometryPrimitiveGrid2Like" [key]="'basis1X'" [label]="'Basis1 X'"></cm-value-slot>
                <cm-value-slot [node]="meshGeometryPrimitiveGrid2Like" [key]="'basis1Y'" [label]="'Basis1 Y'"></cm-value-slot>
                <cm-value-slot [node]="meshGeometryPrimitiveGrid2Like" [key]="'basis2X'" [label]="'Basis2 X'"></cm-value-slot>
                <cm-value-slot [node]="meshGeometryPrimitiveGrid2Like" [key]="'basis2Y'" [label]="'Basis2 Y'"></cm-value-slot>
                <cm-value-slot [node]="meshGeometryPrimitiveGrid2Like" [key]="'numXSegments'" [label]="'Number of X segments'"></cm-value-slot>
                <cm-value-slot [node]="meshGeometryPrimitiveGrid2Like" [key]="'numYSegments'" [label]="'Number of Y segments'"></cm-value-slot>
            }
        </ng-container>
    </cm-inspector-section>
}
@if ($labelPrimitivesOperatorLike(); as labelPrimitivesOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="labelPrimitivesOperatorLike" [key]="'attribute'" [label]="'Attribute'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($weldOperatorLike(); as weldOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="weldOperatorLike" [key]="'attribute'" [label]="'Attribute'"></cm-value-slot>
            <cm-value-slot [node]="weldOperatorLike" [key]="'tolerance'" [label]="'Tolerance'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
@if ($normalsOperatorLike(); as normalsOperatorLike) {
    <cm-inspector-section>
        <ng-container cm-content>
            <cm-value-slot [node]="normalsOperatorLike" [key]="'positionAttribute'" [label]="'Position attribute'"></cm-value-slot>
            <cm-value-slot [node]="normalsOperatorLike" [key]="'smoothingAttribute'" [label]="'Smoothing attribute'"></cm-value-slot>
        </ng-container>
    </cm-inspector-section>
}
